import { lazy } from 'react';
import { Navigate, RouteObject } from 'react-router-dom';
import { IUserData } from 'services/LoginService';
import path, { FirstRoute, Route } from '../path';
import { Loadable } from '../utils';

const Notification = Loadable(
  lazy(() => import('pages/notification/Notification')),
);
const NotificationCenter = Loadable(
  lazy(
    () => import('pages/notification/notificationCenter/NotificationCenter'),
  ),
);

const generateNotificationRoutes = (loginUser: IUserData | null) => {
  if (!loginUser) {
    return null;
  }

  return {
    path: Route.notification,
    element: <Notification />,
    children: (() => {
      const firstFolder: RouteObject[] = [
        {
          element: (
            <Navigate
              to={(() => {
                return path.NOTIFICATION_CENTER;
              })()}
            />
          ),
          index: true,
        },
      ];

      firstFolder.push({
        path: FirstRoute.notificationcenter,
        element: <NotificationCenter />,
      });

      return firstFolder;
    })(),
  };
};

export { generateNotificationRoutes };
